import React from "react";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
export default function CompletedOrder(props) {
  const navigate = useNavigate();
  const order_details = (id) => {
    localStorage.setItem("orderId", id);
    navigate("/order_details");
  };
  const review_order = (id) => {
    navigate("/reviews", { state: { bookingId: id } });
  };
  return (
    <div className="bg-white rounded-md py-5 md:px-6 px-4 space-y-1">
      <div className="flex justify-between items-center">
        <h1 className="font-medium text-2xl text-themeRed md:text-start text-center">
          Order#{props.orderNo}
        </h1>
        <div className="space-y-1">
          <button
            className="font-medium text-xl text-themeBlue2 border border-themeBlue2 bg-themeBlue7 rounded py-1 px-4 w-36
            flex items-center gap-x-2"
          >
            <span>Packages : {props.totalPackages}</span>
          </button>
          <button
            className="font-medium text-xl text-themeBlue2 border border-themeBlue2 bg-themeBlue7 rounded py-1 px-4 w-36
            flex items-center gap-x-2"
          >
            <span>Products : {props.totalProducts}</span>
          </button>
        </div>
      </div>

      <p className="font-normal text-base text-black text-opacity-60 md:text-start text-center">
        Delivered at <Moment format="D MMM , YYYY hh:mm a">{props.time}</Moment>
      </p>
      <p>
        Status :{" "}
        <span className="text-themeRed font-semibold">
          {props.bookingStatus}
        </span>
      </p>
      <p>
        Total Price :{" "}
        <span className="text-themeRed font-semibold">
          ${props.confirmTotalPrice}
        </span>
      </p>
      <p>
        Service Type :{" "}
        <span className="text-themeRed font-semibold">{props.serviceType}</span>
      </p>
      <div className="flex gap-x-2 items-center justify-between">
        <button
          onClick={() => review_order(props.orderNo)}
          className="flex items-center gap-x-2 bg-themeYellowLight border border-themeYellow rounded w-fit px-2 py-1"
        >
          <div>
            <img
              src="images/dashboard/review.webp"
              alt="review"
              className="w-6"
            />
          </div>
          <span className="font-normal text-sm underline">Notes</span>
          <div
            className="font-normal text-xs text-white bg-themeYellow w-5 h-5 flex 
              justify-center items-center rounded-fullest"
          >
            <span>{props.reviews}</span>
          </div>
        </button>
        <button
          className="py-1 px-10 bg-themeBlue text-white border border-themeBlue rounded hover:bg-white hover:text-themeBlue"
          onClick={() => order_details(props.orderNo)}
        >
          Details
        </button>
      </div>
    </div>
  );
}
